<template>
  <li class="ml-4 list-inside list-disc pl-2 font-medium">
    <slot />
  </li>
</template>
